export default __webpack_public_path__ + "static/media/LEVC.37b6043d.png";